import React, {useCallback, useContext, useEffect, useState} from 'react'
import {useParams, useNavigate} from 'react-router-dom'
import {useHttp} from '../hooks/http.hook'
import {AuthContext} from '../context/AuthContext'
import config from '../config.json'
import {getAuthHeader, getPathBack, removeCookieOfFolderId, setDataModalFromCatch, setErrorWindow} from "../functions"
import {ModalWin} from "./ModalWin"
import {LoaderClass} from "./LoaderClass"

export const DeletePage = (string) => {

    const auth = useContext(AuthContext)
    const navigate = useNavigate()
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const [allowedCatch, setAllowedCatch] = useState(true)
    const [dataModalCatch, setDataModalCatch] = useState({})
    const {request, loading} = useHttp()
    const id = useParams().id

    const getData = useCallback(async () => {
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            const data = await request(
                `${host}/api/${string.string}/remove/${id}`,
                'DELETE',
                null,
                {
                    Authorization: getAuthHeader(auth)
                })

            if (data.status > 200) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code))
            } else {
                const folderParentArr = getPathBack().split('/')
                const folderParent = getPathBack().split('/')[folderParentArr.length - 1]
                removeCookieOfFolderId(folderParent)
                // alert(data.message)
                navigate(getPathBack())
            }

        } catch (e) {
            setAllowedCatch(false)
            setDataModalCatch(setDataModalFromCatch(e))
        }
    }, [auth, id, request, string, navigate])

    useEffect(() => {
        getData().then()
    }, [getData])

    if (loading) {
        return <LoaderClass />
    }

    if (!allowed) {
        return (
            <>
                <ModalWin data={dataModal}/>
            </>

        )
    }

    if (!allowedCatch) {
        return (
            <ModalWin data={dataModalCatch}/>
        )
    }
}
